module.exports = __webpack_public_path__ + "static/media/logo.7aae2b57.svg";